import { compressSelector } from "store/features/compress/selectors/compressSelector";
import { CompressState } from "store/features/compress/types";
import { useAppSelector } from "store/store";
import {useWindowSize} from "@/hooks/utils/useWindowSize";

export const usePreview = () => {
    const { images, selectedImageId } = useAppSelector(compressSelector, equalityFn);
    const {height} = useWindowSize()
    const shouldApplyVerticalOptimizationForSmallScreen = height < 800;
    return { images, selectedImageId,shouldApplyVerticalOptimizationForSmallScreen };
};

const equalityFn = (left: CompressState, right: CompressState) => {
    if (left.images.length !== right.images.length || left.selectedImageId !== right.selectedImageId) {
        return false;
    }

    return true;
};
